// 20181120
// 近三个月，今年内，2017，2016.。。。。。
// 规则
// 1.近三个月其实大于等于3个月小于等于4个月
// 2.如果当前月份小于5，则不显示今年内
// 3.今年内->结束时间显示当前月份减去4个月的月份的最后一天之前的数据

import { WUYI } from '@/api/common';

var dateLimit = {
  startYear: 2016, // 开始年份
  getThreeMonth() {
    const date = new Date();
    let year = date.getFullYear();
    let month = date.getMonth() + 1 - 3;
    if (month < 1) {
      month = 12 - month * -1;
      year--;
    }
    const mindate = new Date(year + '/' + (month < 10 ? '0' + month : month) + '/' + '01 00:00:00');
    return mindate;
  },
  getSixMonth() {
    const date = new Date();
    let year = date.getFullYear();
    let month = date.getMonth() + 1 - 6;
    if (month < 1) {
      month = 12 - month * -1;
      year--;
    }
    const mindate = new Date(year + '/' + (month < 10 ? '0' + month : month) + '/' + '01 00:00:00');
    return mindate;
  },
  getCurrentMonth() {
    const date = new Date();
    let year = date.getFullYear();
    let month = date.getMonth() + 1;
    const mindate = new Date(year + '/' + (month < 10 ? '0' + month : month) + '/' + '01 00:00:00');
    return mindate;
  },
  createYear() {
    var years = [
      {
        text: '近三个月',
        value: 0
      }
    ];
    var year = new Date().getFullYear();
    var month = new Date().getMonth() + 1;
    for (var i = year; i >= dateLimit.startYear; i--) {
      var obj = {
        text: '',
        value: i
      };
      if (i == year) {
        if (month > 4) {
          // 当前月份小于5月份不显示今年内
          obj.text = '今年内';
        } else {
          continue;
        }
      } else {
        obj.text = `${i}年`;
      }
      years.push(obj);
    }
    return years;
  },
  currentDayStart: new Date(WUYI.time.timeend),
  currentDayEnd: new Date(WUYI.time.timeend + WUYI.time.oneday - 1000)
};
export default dateLimit;
